module.exports = __webpack_public_path__ + "img/cq-tab-icon1.678fb9da.png";